import { render, staticRenderFns } from "./TranProgramActivityCreateDetail.vue?vue&type=template&id=f794f66a"
import script from "./TranProgramActivityCreateDetail.vue?vue&type=script&lang=js"
export * from "./TranProgramActivityCreateDetail.vue?vue&type=script&lang=js"
import style0 from "./TranProgramActivityCreateDetail.vue?vue&type=style&index=0&id=f794f66a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports